import { z } from "zod";

import { branded } from "@/lib/helpers/branded-helper";

export const refSiteTypeDtoSchema = z.object({
  id: branded.siteTypeId,
  accommodation: z.boolean(),
  description: z.string(),
  translationKey: z.string().nullable(),
});

export type TRefSiteTypeDto = z.infer<typeof refSiteTypeDtoSchema>;
